<template>
    <div class="check-reverse">
        <div style="text-align: center;">
            <el-button type="text" size="mini" @click.native="handleChoose('1')">全选</el-button>
            <el-button type="text" size="mini" @click.native="handleChoose('2')">反选</el-button>
        </div>
        <div style="margin-top: 0.2rem;">
            <el-checkbox-group v-model="checkList" v-if="!tooltip">
                <el-checkbox class="el-ch" v-for="(item, index) in options" :key="index" :label="item[label]"
                    :disabled="item.disable ? fasle : item.disable">{{ item[show] }}</el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group v-model="checkList" v-else>
                <el-tooltip effect="dark" v-for="(item, index) in options" :key="index" :content="item.tooltip_content"
                    placement="top">
                    <el-checkbox class="el-ch" :label="item[label]" :disabled="item.disable ? fasle : item.disable">
                        {{ item[show] }}
                    </el-checkbox>
                </el-tooltip>
            </el-checkbox-group>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CheckReverse',
    data() {
        return {
            checkList: []
        }
    },
    props: {
        options: {
            type: Array
        },
        label: {
            type: String
        },
        show: {
            type: String
        },
        tooltip: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleChoose(val) {
            if (val === '1') {
                this.checkList = []
                this.options.map(item => {
                    this.checkList.push(item[this.label])
                })
            } else if (val === '2') {
                this.options.map(item => {
                    let index = this.checkList.indexOf(item[this.label])
                    if (index !== -1) {
                        this.checkList.splice(index, 1)
                    } else {
                        this.checkList.push(item[this.label])
                    }
                })
            }
        }
    }
}
</script>

<style scoped>
.check-reverse .el-ch {
    margin-bottom: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/commonReform/CheckReverse.vue